<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="加水点">
              <j-search-select-tag
                @change="searchQuery"
                dict="`iwt-wf`.dev_list,dev_name,id, del_flag=0 order by sort asc"
                placeholder="请选择加水点"
                ref="devSelect"
                v-if=" !userInfo.thirdAccount"
                v-model="queryParam.devId"
              />

              <j-search-select-tag
                :dictOptions="devOptions"
                @change="searchQuery"
                placeholder="请选择加水点"
                v-if=" !!userInfo.thirdAccount"
                v-model="queryParam.devId"
              />
            </a-form-item>
          </a-col>
          <a-col
            :lg="5"
            :md="5"
            :sm="24"
            :xl="5"
            v-if=" !userInfo.thirdAccount && !hiddenQueryItems.includes('corpId')"
          >
            <a-form-item label="用水企业">
              <j-search-select-tag
                @change="corpChange"
                dict="`iwt-wf`.wf_consumer_corp,corp_name,id, 1=1 order by corp_name asc"
                placeholder="请选择用水企业"
                ref="corpSelect"
                v-model="queryParam.corpId"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="6" :md="6" :sm="24" :xl="6" v-if=" userInfo.thirdAccount ">
            <a-form-item label="班组">
              <j-search-select-tag
                :dictOptions="consGroupOptions"
                @change="groupChange"
                placeholder="请选择班组"
                v-model="queryParam.groupId"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="取水人">
              <j-search-select-tag
                :dictOptions="consUserOptions"
                @change="searchQuery"
                placeholder="请选择取水人"
                v-model="queryParam.consumerUserId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="加水时间">
              <a-range-picker
                :placeholder="['起始时间', '结束时间']"
                @change="getList"
                format="YYYY-MM-DD"
                v-model="timeRange"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="状态">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="wf_record_status"
                placeholder="请选择更新方式"
                type="checkbox"
                v-model="queryParam.curStatus"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="4" :md="4" :sm="24" :xl="4">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator flex items-center">
      <a-button @click="handleExportXls(generateFileName())" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>

      <div class="ml-80px">
        <a-statistic :precision="0" :value="searchedTotalTimes" title="加水次数" />
      </div>
      <div class="ml-80px">
        <a-statistic :precision="1" :value="searchedTotalRealVolume" title="加水量汇总 (吨)" />
      </div>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        本页合计加水量
        <a style="font-weight: 600">{{ totalRealVolume }}</a>吨，
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="statusSlot" slot-scope="curStatus, record">
          <a-tag :color=" record.curStatus == 0 ? '#ff4d4f' : '#52c41a' ">{{record.curStatus_dictText}}</a-tag>
        </span>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="changeVehicle(record)">修改</a>
        </span>
      </a-table>
    </div>
    <WfconsumerRecordUsualModal @ok="modalFormOk" ref="changeVehicleModal"></WfconsumerRecordUsualModal>
  </a-card>
</template>

<script>
  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfconsumerRecordUsualModal from './modules/WfconsumerRecordUsualModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { validatenull, validatenotnull } from '@/utils/validate'
  export default {
    name: 'WfConsumerRecordList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfconsumerRecordUsualModal
    },
    props: {
      //表单禁用
      filter: {
        type: Object,
        default: () => { },
      }
    },
    watch: {
      filter: {
        handler () {
          this.searchQuery();
        },
        deep: true
      }
    },
    data () {
      return {
        description: '加水记录管理页面',
        timeRange: [],
        isorter: {
          column: 'startTime',
          order: 'desc',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '设备',
            align: "center",
            sorter: true,
            dataIndex: 'devId_dictText'
          },
          {
            title: '用水企业',
            align: "center",
            sorter: true,
            dataIndex: 'corpId_dictText'
          },
          {
            title: '班组',
            align: "center",
            sorter: true,
            dataIndex: 'groupId_dictText'
          },
          {
            title: '取水人',
            align: "center",
            sorter: true,
            dataIndex: 'consumerUserId_dictText'
          },
          {
            title: '水车',
            align: "center",
            sorter: true,
            dataIndex: 'vehicleId_dictText'
          },
          {
            title: '取水量',
            align: "center",
            sorter: true,
            dataIndex: 'realVolume',
            customRender: function (text) {
              return Math.round(parseFloat(text) * 10) / 10;
            }
          },
          {
            title: '状态',
            align: "center",
            sorter: true,
            dataIndex: 'curStatus',
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title: '开始时间',
            align: "center",
            sorter: true,
            dataIndex: 'startTime'
          },
          {
            title: '结束时间',
            align: "center",
            sorter: true,
            dataIndex: 'endTime'
          },
          {
            title: '结束原因',
            align: "center",
            sorter: true,
            dataIndex: 'endReason_dictText',
            // scopedSlots: { customRender: 'endReasonSlot' }
          },
          {
            title: '用水单位',
            align: "center",
            sorter: true,
            dataIndex: 'customerId_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/wf/wfConsumerRecord/list",
          stat: "/wf/wfConsumerRecord/stat",
          delete: "/wf/wfConsumerRecord/delete",
          deleteBatch: "/wf/wfConsumerRecord/deleteBatch",
          exportXlsUrl: "/wf/wfConsumerRecord/exportXls",
          importExcelUrl: "wf/wfConsumerRecord/importExcel",
          corpDevList: 'device/devList/corpList',
          corpGroupList: 'wf/corpGroup/list',
          corpUserList: "/custom/user/list",
        },
        localFilter: {},
        dictOptions: {},
        devOptions: [],
        consUserOptions: [],

        consGroupOptions: [],
        superFieldList: [],
        disableMixinCreated: true,

        searchedTotalTimes: 0,
        searchedTotalRealVolume: 0,
      }
    },
    created () {
      this.getSuperFieldList();

      //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
      if (!!this.userInfo.thirdAccount) {
        this.localFilter = {
          corpId: this.userInfo.corpIds
        }
        this.getDevList();
      }

      if (this.filter?.corpId || this.localFilter?.corpId) {
        this.columns = this.columns.filter(col => col.dataIndex !== 'corpId_dictText')
        //写入queryParam，查询和导出都增加过滤条件
        this.queryParam.corpId = this.queryParam.corpId = this.filter?.corpId || this.localFilter?.corpId;
      }

      // 在 localFilter 设置完成后调用 loadData
      this.$nextTick(() => {
        this.loadData(1);
      });

      this.getConsGroup();
      this.getConsUser();
    },
    computed: {
      importExcelUrl () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      totalRealVolume () {
        return this.dataSource.reduce((total, current) => total + Math.round(parseFloat(current.realVolume) * 10), 0) / 10;
      },
      hiddenQueryItems () {
        return this.filter ? Object.keys(this.filter) : [];
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    methods: {
      getList () {
        if (validatenull(this.timeRange)) {
          this.queryParam.startTime_begin = null
          this.queryParam.startTime_end = null
        } else {
          this.queryParam.startTime_begin = this.timeRange[0] + ' 00:00:00'
          this.queryParam.startTime_end = this.timeRange[1] + ' 23:59:59'
        }
        this.searchQuery()
      },
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams()// 查询条件
        this.loading = true;
        // 合并 localFilter 和 filter
        const mergedFilter = { ...this.localFilter, ...this.filter };
        Object.assign(params, mergedFilter);

        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          }
        }).finally(() => {
          this.loading = false
        });

        getAction(this.url.stat, params).then((res) => {
          if (res.success) {
            this.searchedTotalRealVolume = res.result?.volumes || 0;
            this.searchedTotalTimes = res.result?.times || 0;
          }
        })
      },
      corpChange () {
        this.queryParam.groupId = null;
        this.queryParam.consumerUserId = null;
        this.searchQuery();
        this.getConsGroup();
        this.getConsUser();
      },
      groupChange () {
        this.queryParam.consumerUserId = null;
        this.searchQuery();
        this.getConsUser();
      },
      getConsGroup () {
        if (!this.userInfo.thirdAccount) {
          return;
        }
        this.consGroupOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          column: 'groupName',
          order: 'asc',
        };
        getAction(this.url.corpGroupList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(group => {
              this.consGroupOptions.push({
                value: group.id,
                text: group.groupName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getConsUser () {
        // if (!this.userInfo.thirdAccount) {
        //   return;
        // }
        this.consUserOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          groupId: this.queryParam.groupId,
          column: 'username',
          order: 'asc',
        };
        getAction(this.url.corpUserList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(user => {
              this.consUserOptions.push({
                value: user.id,
                text: user.nickname
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getDevList () {
        getAction(this.url.corpDevList, { pageSize: 999999 }).then((res) => {
          if (res.success) {
            res.result.records.forEach(device => {
              this.devOptions.push({
                value: device.id,
                text: device.devName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      generateFileName () {
        let filname = '加水记录';
        if (this.queryParam.startTime_begin) {
          const startTimeStr = this.queryParam.startTime_begin.substring(0, 10).replaceAll('-', '');
          const endTimeStr = this.queryParam.startTime_end.substring(0, 10).replaceAll('-', '');
          filname += `_${startTimeStr}`;
          if (startTimeStr !== endTimeStr) {
            filname += `_${endTimeStr}`;
          }
        }
        if (this.queryParam.corpId && !this.userInfo.thirdAccount && !this.hiddenQueryItems.includes('corpId')) {
          const corpId = this.queryParam.corpId;
          let corpName = '';
          //获取下拉选择corpId对应的corpName
          const option = this.$refs.corpSelect.options.find(opt => opt.value === corpId);
          corpName = option ? option.text : '';
          if (corpName) {
            filname += `_${corpName}`;
          }
        }
        if (this.queryParam.devId) {
          const devId = this.queryParam.devId;
          let devName = '';
          //获取下拉选择devId对应的devName
          if (!this.userInfo.thirdAccount) {
            const option = this.$refs.devSelect.options.find(opt => opt.value === devId);
            devName = option ? option.text : '';
          } else {
            const option = this.devOptions.find(opt => opt.value === devId);
            devName = option ? option.text : '';
          }

          if (devName) {
            filname += `_${devName}`;
          }
        }
        return filname;
      },
      changeVehicle (record) {
        this.$refs.changeVehicleModal.show(record);
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'orderNo', text: '订单号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devId', text: '设备', dictCode: '`iwt-wf`.dev_list,dev_name,id' })
        fieldList.push({ type: 'string', value: 'consumerUserId', text: '取水人', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'planVolume', text: '计划取水量', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'realVolume', text: '实际取水量', dictCode: '' })
        fieldList.push({ type: 'int', value: 'curStatus', text: '当前状态', dictCode: '' })
        fieldList.push({ type: 'date', value: 'startTime', text: '开始时间' })
        fieldList.push({ type: 'date', value: 'endTime', text: '结束时间' })
        fieldList.push({ type: 'string', value: 'endReason', text: '结束原因', dictCode: '' })
        fieldList.push({ type: 'int', value: 'usedMinutes', text: '加水时长(分钟)', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'realFlowrate', text: '实际流速(m³/h)', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>